<template>
  <div class="tw-mb-6">
    <select
      :style="selectStyle"
      v-model="selectedLeitura"
      @change="onChange"
      :class="[
        'tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-text-sm tw-font-medium tw-appearance-none custom-scrollbar',
        theme === 'dark'
          ? 'tw-bg-slate-700 tw-text-slate-100'
          : 'tw-bg-[#E9EEF6] tw-text-slate-900 '
      ]"
    >
      <option disabled value="">Selecione uma leitura</option>
      <option v-for="(leitura, index) in leituras" :key="index" :value="leitura._id">
        {{ leitura.data }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
    props: {
        leituras: {
            type: Array,
            default: () => [],
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {
            selectedLeitura: "",
        };
    },
    methods: {
        onChange() {
            this.$emit('changeLeitura', this.selectedLeitura);
        },
    },
    computed: {
        selectStyle() {
          const fill = this.theme === 'dark' ? '%23fff' : '%23333';

          return {
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='${fill}' d='M6 9L1 4h10z'/%3E%3C/svg%3E")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 0.75rem center',
            backgroundSize: '1.5em 1.5em',
            paddingRight: '2.5rem',
          };
        }
    }
};
</script>